export default {"src":"/_next/static/media/Olivia.726c0abe.svg","height":45,"width":44,"blurWidth":0,"blurHeight":0};